const CHATBOT_BASE_URL = process.env.REACT_APP_RAG_API_URL || "https://rag.bulkhours.com";

export const chatbotService = {
  // Send question to RAG Engine using /ask endpoint
  askQuestion: async (question) => {
    try {
      const response = await fetch(`${CHATBOT_BASE_URL}/ask`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          question: question,
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          // Try to refresh token and retry
          await chatbotService.refreshToken();
          // Retry the request
          const retryResponse = await fetch(`${CHATBOT_BASE_URL}/ask`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              question: question,
            }),
          });
          
          if (!retryResponse.ok) {
            throw new Error(`HTTP error! status: ${retryResponse.status}`);
          }
          
          const retryData = await retryResponse.json();
          return retryData;
        }
        
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Chatbot service error:", error);
      throw error;
    }
  },

  // Generate reply with Slack formatting (alternative endpoint)
  generateReply: async (text, user = "user") => {
    try {
      const response = await fetch(`${CHATBOT_BASE_URL}/generate-reply`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: user,
          text: text,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      
      // Convert Slack formatting to HTML for frontend display
      const formattedReply = data.reply
        .replace(/\*(.*?)\*/g, '<strong>$1</strong>')  // Bold
        .replace(/_(.*?)_/g, '<em>$1</em>')             // Italic
        .replace(/`(.*?)`/g, '<code>$1</code>')         // Code
        .replace(/\n/g, '<br>');                        // Line breaks

      return {
        ...data,
        formattedReply: formattedReply
      };
    } catch (error) {
      console.error("Chatbot service error:", error);
      throw error;
    }
  },

  // Refresh authentication token
  refreshToken: async () => {
    try {
      const response = await fetch(`${CHATBOT_BASE_URL}/refresh-token`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Token refresh error:", error);
      throw error;
    }
  },

  // Check API health/status using /ping endpoint
  checkHealth: async () => {
    try {
      const response = await fetch(`${CHATBOT_BASE_URL}/ping`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.message === "pong";
    } catch (error) {
      console.error("Health check error:", error);
      return false;
    }
  },
};

export default chatbotService;
